<template>
  <section class="page-privacy prose">
    <div class="page-privacy__body container">
      <LegalPagesNavigation />

      <h1>
        {{ $t('privacyPolicy.title') }}
      </h1>

      <i18n path="privacyPolicy.introduction" tag="p">
        <template #concept>
          <TBtnLink to="/" target="_blank">
            {{ concept }}
          </TBtnLink>
        </template>
      </i18n>

      <h2>
        {{ $t('privacyPolicy.section1Title') }}
      </h2>
      <p>
        {{ $t('privacyPolicy.section1Body1') }}
      </p>
      <p>
        {{ $t('privacyPolicy.companyAddressStreet') }}<br />
        {{ $t('privacyPolicy.companyZipcode') }}<br />
        {{ $t('privacyPolicy.companyAddressCity') }}<br /><br />
        {{ $t('privacyPolicy.companyChamberOfCommerce') }}
      </p>
      <i18n path="privacyPolicy.section1Body2" tag="p">
        <template #concept>
          <TBtnLink to="/" target="_blank">
            {{ concept }}
          </TBtnLink>
        </template>
      </i18n>

      <h2>
        {{ $t('privacyPolicy.section2Title') }}
      </h2>
      <p>
        {{ $t('privacyPolicy.section2Body1') }}
      </p>

      <h2>
        {{ $t('privacyPolicy.section3Title') }}
      </h2>
      <p>
        {{ $t('privacyPolicy.section3Body1') }}
      </p>
      <ul>
        <li>{{ $t('privacyPolicy.section3List1Item1') }}</li>
        <li>
          {{ $t('privacyPolicy.section3List1Item2') }}
          <ul>
            <li>{{ $t('privacyPolicy.section3List1Item2Sub1') }}</li>
            <li>{{ $t('privacyPolicy.section3List1Item2Sub2') }}</li>
            <li>{{ $t('privacyPolicy.section3List1Item2Sub2') }}</li>
            <li>{{ $t('privacyPolicy.section3List1Item2Sub3') }}</li>
            <li>{{ $t('privacyPolicy.section3List1Item2Sub4') }}</li>
          </ul>
        </li>
      </ul>
      <p>
        {{ $t('privacyPolicy.section3Body2') }}
      </p>
      <ul>
        <li>{{ $t('privacyPolicy.section3List2Item1') }}</li>
        <li>{{ $t('privacyPolicy.section3List2Item2') }}</li>
        <li>{{ $t('privacyPolicy.section3List2Item3') }}</li>
      </ul>

      <h2>
        {{ $t('privacyPolicy.section4Title') }}
      </h2>
      <p>
        {{ $t('privacyPolicy.section4Body') }}
      </p>

      <h2>
        {{ $t('privacyPolicy.section5Title') }}
      </h2>
      <i18n path="privacyPolicy.section5Body" tag="p">
        <template #concept>
          <TBtnLink to="/" target="_blank">
            {{ concept }}
          </TBtnLink>
        </template>
      </i18n>

      <h2>
        {{ $t('privacyPolicy.section6Title') }}
      </h2>
      <p>
        {{ $t('privacyPolicy.section6Body') }}
      </p>

      <h2>
        {{ $t('privacyPolicy.section7Title') }}
      </h2>
      <i18n path="privacyPolicy.section7Right1" tag="p">
        <template #title>
          <strong>
            {{ $t('privacyPolicy.section7Right1Title') }}
          </strong>
        </template>
      </i18n>
      <i18n path="privacyPolicy.section7Right2" tag="p">
        <template #title>
          <strong>
            {{ $t('privacyPolicy.section7Right2Title') }}
          </strong>
        </template>
        <template #concept>
          <TBtnLink to="/" target="_blank">
            {{ concept }}
          </TBtnLink>
        </template>
      </i18n>
      <i18n path="privacyPolicy.section7Right3" tag="p">
        <template #title>
          <strong>
            {{ $t('privacyPolicy.section7Right3Title') }}
          </strong>
        </template>
      </i18n>
      <i18n path="privacyPolicy.section7Right4" tag="p">
        <template #title>
          <strong>
            {{ $t('privacyPolicy.section7Right4Title') }}
          </strong>
        </template>
        <template #concept>
          <TBtnLink to="/" target="_blank">
            {{ concept }}
          </TBtnLink>
        </template>
      </i18n>
      <i18n path="privacyPolicy.section7Right5" tag="p">
        <template #title>
          <strong>
            {{ $t('privacyPolicy.section7Right5Title') }}
          </strong>
        </template>
      </i18n>
      <i18n path="privacyPolicy.section7Right6" tag="p">
        <template #title>
          <strong>
            {{ $t('privacyPolicy.section7Right6Title') }}
          </strong>
        </template>
      </i18n>

      <p>
        {{ $t('privacyPolicy.section7Body') }}
      </p>

      <h2>
        {{ $t('privacyPolicy.section8Title') }}
      </h2>
      <i18n path="privacyPolicy.section8Body" tag="p">
        <template #email>
          <TBtnLink class="t-btn" href="mailto:info@bambelo.com">
            info@bambelo.com
          </TBtnLink>
        </template>
      </i18n>

      <h2>
        {{ $t('privacyPolicy.section9Title') }}
      </h2>
      <p>
        {{ $t('privacyPolicy.section9Body') }}
      </p>

      <h2>
        {{ $t('privacyPolicy.section10Title') }}
      </h2>
      <i18n path="privacyPolicy.section10Body" tag="p">
        <template #email>
          <TBtnLink class="t-btn" href="mailto:info@bambelo.com">
            info@bambelo.com
          </TBtnLink>
        </template>
      </i18n>

      <h2>
        {{ $t('privacyPolicy.section11Title') }}
      </h2>
      <i18n path="privacyPolicy.section11Body" tag="p">
        <template #link>
          <TBtnLink
            class="t-btn"
            target="_blank"
            :href="$t('privacyPolicy.section11BodyLink')"
          >
            {{ $t('privacyPolicy.section11BodyLinkText') }}
          </TBtnLink>
        </template>
      </i18n>

      <h2>
        {{ $t('privacyPolicy.section12Title') }}
      </h2>
      <p>
        {{ $t('privacyPolicy.section12Body') }}
      </p>

      <p class="page-privacy__version">
        <strong>{{ $t('privacyPolicy.version') }}</strong>
      </p>
    </div>
  </section>
</template>

<script>
import LegalPagesNavigation from 'chimera/all/page/LegalPagesNavigation'
import AbstractPrivacyPage from './AbstractPrivacyPage'

export default {
  name: 'PrivacyPage',

  components: {
    LegalPagesNavigation,
  },

  extends: AbstractPrivacyPage,
}
</script>
